module.exports = __webpack_public_path__ + "img/form.10dfd9d9.png";